/**
 *
 * Asynchronously loads the component for OfflineServiceTypes Page
 *
 */
import { lazyLoad } from 'utils/loadable';

export const OfflineServiceTypesPage = lazyLoad(
  () => import('./index'),
  module => module.OfflineServiceTypesPage,
);
